export default __webpack_public_path__ + "static/media/ontime.dc884613.svg";